import React, { ReactChild } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import SVGCivicLogo from '../svg/SVGCivicLogo';
import WalletAdapterButton from '../WalletConnection/WalletAdapterButton';
import SVGBack from '../svg/SVGBack';

interface ChildProps {
  children: ReactChild | ReactChild[];
  showBackButton?: boolean;
}

export default function MainContainer({ children, showBackButton }: ChildProps): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  const backAction = () => {
    history.goBack();
  };

  return (
    <div className="main-container">
      <div className="top-panel">
        <div className="top-panel-main-logo">
          <span className="connect-button-positioner">
            <WalletAdapterButton className="buttonSecondary" buttonLabel={t('button.connect')} />
          </span>
          <div className="main-logo-positioner">
            <div>
              <div className="ml-6 mr-8 mt-1 float-left">
                {showBackButton && (
                  <>
                    <div className="float-left mr-1">
                      <SVGBack />
                    </div>
                    <div className="float-left -mt-0.5">
                      <button type="button" onClick={backAction}>
                        {t('back')}
                      </button>
                    </div>
                  </>
                )}
              </div>
              <div className="mt-4 float-left flex flex-row justify-center items-center w-full">
                <div className="float-none">
                  <SVGCivicLogo />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-panel"> {children} </div>
      <div className="textFooter text-center">
        <span className="mt-4">{t('copyright')}</span>
      </div>
    </div>
  );
}

MainContainer.defaultProps = {
  showBackButton: false,
};
